// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnchoredBanner_bannerContainer__EEoYb {
    position: fixed;
    top: 0;
    z-index: 60;
}
.AnchoredBanner_bannerContainerClosed__Hlv8y{
    z-index: -1;
}

.AnchoredBanner_banner__VWZH\\+ {
    display: flex;
    gap: 16px;
    position: fixed;
    width: calc(100% - 30px); /* 30px to account for horizontal spacing around the banner */
    max-width: 400px;
    padding: 0 16px;
    background-color: var(--color-106);
    outline: 0;
    border:1px solid var(--color-lightui-surface-4);
    box-shadow: 0 0.1rem 1rem rgba(15, 15, 15, 0.12);
    box-sizing: border-box;
    background-clip: padding-box;
    border-radius: 8px;
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transition: height 400ms;
    transition: height 400ms;
}

.AnchoredBanner_bannerLeft__9ZoXs {
    top: 73px;
    left: 65px;
    right: 15px;
    margin-right: auto;
    width: calc(100% - 80px); /* 80px to account for left: 65px and right: 15px */
}

.AnchoredBanner_bannerTop__6kKRB {
    top: 45px;
    left: 0;
    right: 0;
    margin: auto;
}

.AnchoredBanner_bannerRight__O\\+P7F {
    top: 73px;
    right: 15px;
    left: 15px;
    margin-left: auto;
    width: calc(100% - 30px); /* 30px to account for right: 15px and left: 15px */
}

.AnchoredBanner_bannerBottom__aaO5N {
    bottom: 45px;
    left: 0;
    right: 0;
    margin: auto;
}

.AnchoredBanner_bannerContent__uXM0w {
    overflow: hidden;
    flex-grow: 1;
}

.AnchoredBanner_bannerHeader__-K285 {
    padding: 8px 0;
    color: var(--color-100);
    overflow: hidden;
}

.AnchoredBanner_bannerHeader__-K285 h3 {
    line-height: inherit;
    padding: 8px 0 3px;
    margin: 0;
    font-weight: 600;
    font-size: 16px;
}

.AnchoredBanner_bannerIconWrapper__S5adj {
    padding: 16px 0;
}

.AnchoredBanner_bannerIcon__2CT4N {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
}

.AnchoredBanner_bannerIcon__2CT4N .AnchoredBanner_icon__hyxCh {
    width: 50px;
    height: 50px;
    min-width: 50px;
    line-height: 50px;
    color: var(--color-text-light);
    margin: 0;
    vertical-align: inherit;
}

.AnchoredBanner_bannerCloseBtn__aRAb2 {
    align-self: flex-start;
    border-radius: 50%;
    margin-top: 16px;
    padding: 5px;
    color: var(--color-darkui-surface-1);
    background-color: var(--color-lightui-accent-1);
    border: none;
    cursor: pointer;
}
.AnchoredBanner_bannerCloseBtn__aRAb2 svg {
    display: block;
}

.AnchoredBanner_bannerBody__ZHJG1 {
    position: relative;
    max-height: calc(100vh - 180px);
    padding-bottom: 16px;
    overflow-y: auto;
    color: var(--color-101);
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Banner/AnchoredBanner/AnchoredBanner.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,wBAAwB,EAAE,6DAA6D;IACvF,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,UAAU;IACV,+CAA+C;IAC/C,gDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;IACpB,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB,EAAE,mDAAmD;AACjF;;AAEA;IACI,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,wBAAwB,EAAE,mDAAmD;AACjF;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,+CAA+C;IAC/C,YAAY;IACZ,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".bannerContainer {\n    position: fixed;\n    top: 0;\n    z-index: 60;\n}\n.bannerContainerClosed{\n    z-index: -1;\n}\n\n.banner {\n    display: flex;\n    gap: 16px;\n    position: fixed;\n    width: calc(100% - 30px); /* 30px to account for horizontal spacing around the banner */\n    max-width: 400px;\n    padding: 0 16px;\n    background-color: var(--color-106);\n    outline: 0;\n    border:1px solid var(--color-lightui-surface-4);\n    box-shadow: 0 0.1rem 1rem rgba(15, 15, 15, 0.12);\n    box-sizing: border-box;\n    background-clip: padding-box;\n    border-radius: 8px;\n    -webkit-transform: scaleY(1);\n    -ms-transform: scaleY(1);\n    transform: scaleY(1);\n    -webkit-transition: height 400ms;\n    transition: height 400ms;\n}\n\n.bannerLeft {\n    top: 73px;\n    left: 65px;\n    right: 15px;\n    margin-right: auto;\n    width: calc(100% - 80px); /* 80px to account for left: 65px and right: 15px */\n}\n\n.bannerTop {\n    top: 45px;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.bannerRight {\n    top: 73px;\n    right: 15px;\n    left: 15px;\n    margin-left: auto;\n    width: calc(100% - 30px); /* 30px to account for right: 15px and left: 15px */\n}\n\n.bannerBottom {\n    bottom: 45px;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.bannerContent {\n    overflow: hidden;\n    flex-grow: 1;\n}\n\n.bannerHeader {\n    padding: 8px 0;\n    color: var(--color-100);\n    overflow: hidden;\n}\n\n.bannerHeader h3 {\n    line-height: inherit;\n    padding: 8px 0 3px;\n    margin: 0;\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.bannerIconWrapper {\n    padding: 16px 0;\n}\n\n.bannerIcon {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    text-align: center;\n}\n\n.bannerIcon .icon {\n    width: 50px;\n    height: 50px;\n    min-width: 50px;\n    line-height: 50px;\n    color: var(--color-text-light);\n    margin: 0;\n    vertical-align: inherit;\n}\n\n.bannerCloseBtn {\n    align-self: flex-start;\n    border-radius: 50%;\n    margin-top: 16px;\n    padding: 5px;\n    color: var(--color-darkui-surface-1);\n    background-color: var(--color-lightui-accent-1);\n    border: none;\n    cursor: pointer;\n}\n.bannerCloseBtn svg {\n    display: block;\n}\n\n.bannerBody {\n    position: relative;\n    max-height: calc(100vh - 180px);\n    padding-bottom: 16px;\n    overflow-y: auto;\n    color: var(--color-101);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerContainer": `AnchoredBanner_bannerContainer__EEoYb`,
	"bannerContainerClosed": `AnchoredBanner_bannerContainerClosed__Hlv8y`,
	"banner": `AnchoredBanner_banner__VWZH+`,
	"bannerLeft": `AnchoredBanner_bannerLeft__9ZoXs`,
	"bannerTop": `AnchoredBanner_bannerTop__6kKRB`,
	"bannerRight": `AnchoredBanner_bannerRight__O+P7F`,
	"bannerBottom": `AnchoredBanner_bannerBottom__aaO5N`,
	"bannerContent": `AnchoredBanner_bannerContent__uXM0w`,
	"bannerHeader": `AnchoredBanner_bannerHeader__-K285`,
	"bannerIconWrapper": `AnchoredBanner_bannerIconWrapper__S5adj`,
	"bannerIcon": `AnchoredBanner_bannerIcon__2CT4N`,
	"icon": `AnchoredBanner_icon__hyxCh`,
	"bannerCloseBtn": `AnchoredBanner_bannerCloseBtn__aRAb2`,
	"bannerBody": `AnchoredBanner_bannerBody__ZHJG1`
};
export default ___CSS_LOADER_EXPORT___;
